module.exports = __webpack_public_path__ + "img/type9.f034bb0f.png";